module.exports = __webpack_public_path__ + "img/main_banner_03.1a70f2e.webp";